<script setup lang="ts">
  import DeleteDialog from '@/components/dialog/DeleteDialog.vue'
  import NoDataAvailableText from '@/components/projectDetail/components/NoDataAvailableText.vue'
  import SecondaryButton from '@/components/shared/SecondaryButton.vue'

  const rasterFileUploadStore = useRasterFileUploadStore()
  const authorizationStore = useAuthorizationStore()

  const { items, currentItem, selectedItems, isSelectedAll } = storeToRefs(rasterFileUploadStore)

  const canDelete = computed(() => {
    return authorizationStore.hasServicePermission({
      authSource: 'ProjectUser',
      allowed: 'delete_rasterfileupload'
    })
  })
</script>

<template>
  <v-lazy>
    <v-list density="compact" class="pt-0 overflow-y-auto">
      <div class="d-flex align-center justify-space-between ml-1 mr-2">
        <div class="d-flex align-center">
          <v-checkbox
            :model-value="isSelectedAll"
            @update:model-value="
              selectedItems.length === items.length
                ? rasterFileUploadStore.clearSelectedRasterFiles()
                : rasterFileUploadStore.selectAllRasterFiles()
            "
            :disabled="!items.length"
            color="primary"
            hide-details
          ></v-checkbox>
          <span>Select all</span>
        </div>
        <SecondaryButton
          v-if="canDelete"
          prepend-icon="mdi-delete"
          :disabled="!selectedItems.length"
          @click="rasterFileUploadStore.removeSelectedRasterFiles()"
        >
          Delete
        </SecondaryButton>
      </div>
      <v-list-item
        v-for="item in items"
        :key="item.id"
        :nav="true"
        density="compact"
        :v-ripple="true"
        class="list-item mb-0 rounded-0"
        :class="{ 'selected-item': selectedItems.includes(item) }"
      >
        <template v-slot:prepend>
          <v-checkbox
            class="ml-n1"
            :model-value="selectedItems.includes(item)"
            @update:model-value="rasterFileUploadStore.toggleSelectedRasterFile(item)"
            color="primary"
            hide-details
          ></v-checkbox>
        </template>
        <template v-slot:title>
          <strong class="pl-2" :style="{ color: item.raster_color }">
            {{ item.name ? item.name : item.source_file_name }}
          </strong>
        </template>
        <template v-slot:subtitle>
          <p class="pl-2">{{ item.source_file_name }}</p>
        </template>
        <template v-slot:append>
          <div
            class="d-flex justify-end align-center h-100 mr-4 cursor-pointer"
            @click="
              rasterFileUploadStore.setCurrentItem(item),
                rasterFileUploadStore.toggleAddRasterFileDialog()
            "
          >
            <v-icon class="text-primary"> mdi-pencil</v-icon>
          </div>
        </template>
      </v-list-item>
      <NoDataAvailableText v-if="!items.length">
        There are no raster files available.
      </NoDataAvailableText>
    </v-list>
  </v-lazy>
  <DeleteDialog :store="rasterFileUploadStore" :name="currentItem?.name"></DeleteDialog>
</template>

<style scoped>
  .selected-item,
  .list-item:hover {
    background-color: #f4fcff;
  }
</style>
